import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { ofArray, singleton, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { parse } from "../../../fable_modules/fable-library-js.4.19.0/Int32.js";
import { Page } from "./Types.fs.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (_arg_1) => (new PageHeader(1, ["Datenübergabe"])), (_arg_3) => (!isEmpty(_arg_3) ? ((head(_arg_3) === "dta") ? (!isEmpty(tail(_arg_3)) ? ((head(tail(_arg_3)) === "page") ? (!isEmpty(tail(tail(_arg_3))) ? (isEmpty(tail(tail(tail(_arg_3)))) ? (new Page(parse(head(tail(tail(_arg_3))), 511, false, 32))) : undefined) : undefined) : undefined) : (new Page(1))) : undefined) : undefined), (_arg_2) => {
    if (_arg_2.fields[0] === 1) {
        return singleton("dta");
    }
    else {
        return ofArray(["dta", "page", int32ToString(_arg_2.fields[0])]);
    }
}, (_arg) => {
    if (_arg.tag === 8) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
